import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';

import App from './App';
const root = ReactDOM.createRoot(document.getElementById('resourceCenter'));
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            colorPrimary: '#3EB044',
            activeBarHeight: 0,
          },
        },
      }}
    >
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

// TODO  增加404和search路由
// TODO  类型和系列 id 相同的问题
// TODO  国际化
